import dynamic from "next/dynamic";
import { useEffect } from "react";
import PageContextWrapper from "./Components/Reusables/PageContextWrapper";
import useRoute from "./_hooks/CSRHooks/useRoute";

const Articles = dynamic(() => import('./Components/Article/Articles'));
const Category = dynamic(() => import('./Components/CategoryComponent/Category'));
const CategoryWrapper = dynamic(() => import('./Components/CategoryComponent/CategoryWrapper'));
const LandingPage = dynamic(() => import('./Components/LandingPages/LandingPage'));


const RouteWrapper = (props) => {
    const {
        exactRoute,
        data,
    } = props;

    const { data: routeData, route, loading, setData, setRoute } = useRoute(data, exactRoute);

    useEffect(() => {
        setData(data);
        setRoute(exactRoute);
    }, [data])

    return (
        <>
            {route == 'category' && (
                <>
                    <CategoryWrapper
                        category={{
                            ...routeData,
                            exactRoute
                        }}
                    >
                        <Category
                            categoryData={{
                                template_page_settings: routeData.template_page_settings,
                                long_term: routeData.long_term,
                            }}
                            loading={loading}
                        />
                    </CategoryWrapper>
                </>
            )}

            {route == 'location' && (
                <PageContextWrapper
                    page='landing'
                    page_content={routeData.template_page_content}
                >
                    <LandingPage loading={loading} {...routeData} />
                </PageContextWrapper>
            )}

            {route == 'article' && (
                <PageContextWrapper
                    page='articles'
                    page_content={routeData.template_page_content}
                >
                    <Articles loading={loading} props={routeData} />
                </PageContextWrapper>
            )}
        </>
    )
}

export default RouteWrapper